// Tied to backend, do not rename values
export enum CsvExportField {
    CONTACT_NAME = 'CONTACT_NAME',
    CONTACT_FIRST_NAME = 'CONTACT_FIRST_NAME',
    CONTACT_LAST_NAME = 'CONTACT_LAST_NAME',
    CONTACT_JOB_TITLE = 'CONTACT_JOB_TITLE' ,
    CONTACT_JOB_ROLE = 'CONTACT_JOB_ROLE',
    CONTACT_BIO = 'CONTACT_BIO',
    CONTACT_SUBJECTS = 'CONTACT_SUBJECTS',
    CONTACT_LANGUAGE = 'CONTACT_LANGUAGE',

    CONTACT_EMAIL = 'CONTACT_EMAIL',
    CONTACT_PHONE = 'CONTACT_PHONE',
    CONTACT_WEBSITE = 'CONTACT_WEBSITE',
    CONTACT_ADDRESS_LINE_1 = 'CONTACT_ADDRESS_LINE_1',
    CONTACT_ADDRESS_LINE_2 = 'CONTACT_ADDRESS_LINE_2',
    CONTACT_CITY = 'CONTACT_CITY',
    CONTACT_COUNTY = 'CONTACT_COUNTY',
    CONTACT_PROVINCE = 'CONTACT_PROVINCE',
    CONTACT_COUNTRY = 'CONTACT_COUNTRY',
    CONTACT_POSTAL_CODE = 'CONTACT_POSTAL_CODE',
    CONTACT_NOTES = 'CONTACT_NOTES',

    CONTACT_INSTAGRAM = 'CONTACT_INSTAGRAM',
    CONTACT_TWITTER = 'CONTACT_TWITTER',
    CONTACT_FACEBOOK = 'CONTACT_FACEBOOK',
    CONTACT_LINKEDIN = 'CONTACT_LINKEDIN',
    CONTACT_TIKTOK = 'CONTACT_TIKTOK',
    CONTACT_BLUESKY = 'CONTACT_BLUESKY',
    CONTACT_YOUTUBE = 'CONTACT_YOUTUBE',


    OUTLET_NAME = 'OUTLET_NAME',
    OUTLET_BIO = 'OUTLET_BIO',
    OUTLET_SUBJECTS = 'OUTLET_SUBJECTS',
    OUTLET_LANGUAGE = 'OUTLET_LANGUAGE',

    OUTLET_EMAIL = 'OUTLET_EMAIL',
    OUTLET_PHONE = 'OUTLET_PHONE',
    OUTLET_WEBSITE = 'OUTLET_WEBSITE',
    OUTLET_ADDRESS_LINE_1 = 'OUTLET_ADDRESS_LINE_1',
    OUTLET_ADDRESS_LINE_2 = 'OUTLET_ADDRESS_LINE_2',
    OUTLET_CITY = 'OUTLET_CITY',
    OUTLET_COUNTY = 'OUTLET_COUNTY',
    OUTLET_PROVINCE = 'OUTLET_PROVINCE',
    OUTLET_COUNTRY = 'OUTLET_COUNTRY',
    OUTLET_POSTAL_CODE = 'OUTLET_POSTAL_CODE',
    OUTLET_NOTES = 'OUTLET_NOTES',

    OUTLET_MEDIA_TYPE = 'OUTLET_MEDIA_TYPE',
    OUTLET_PRODUCT_TYPE = 'OUTLET_PRODUCT_TYPE',
    OUTLET_PRODUCT_FREQUENCY = 'OUTLET_PRODUCT_FREQUENCY',
    OUTLET_MARKET_SECTOR = 'OUTLET_MARKET_SECTOR',
    OUTLET_AUDIENCE_REACH = 'OUTLET_AUDIENCE_REACH',
    OUTLET_TARGET_AUDIENCE = 'OUTLET_TARGET_AUDIENCE',
    OUTLET_COVERAGE_FOCUS = 'OUTLET_COVERAGE_FOCUS',
    OUTLET_AREA_OF_COVERAGE = 'OUTLET_AREA_OF_COVERAGE',

    OUTLET_INSTAGRAM = 'OUTLET_INSTAGRAM',
    OUTLET_TWITTER = 'OUTLET_TWITTER',
    OUTLET_FACEBOOK = 'OUTLET_FACEBOOK',
    OUTLET_LINKEDIN = 'OUTLET_LINKEDIN',
    OUTLET_TIKTOK = 'OUTLET_TIKTOK',
    OUTLET_BLUESKY = 'OUTLET_BLUESKY',
    OUTLET_YOUTUBE = 'OUTLET_YOUTUBE',

    LISTS = 'LISTS'
}
